<template>
  <div class="container">
    <div v-if="showReturnLink" style="margin-bottom: 1rem;">
      <button class="button is-link is-light" @click="navigateBack">
        <span class="icon"><i class="fas fa-arrow-left"></i></span>
        <span>Back to ACID Documents</span>
      </button>
    </div>
    <iframe :src="pdfData" style="width:100%; border: 0; height:800px; padding:10px" id="pdf-frame" ref="pdfFrame" v-if="!loading" />
  </div>
</template>
<script>
  export default {
    props: {
      source: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        loading: true,
        resolvedObjectUrl: null
      }
    },
    computed: {
      decodedSource() {
        try {
          return decodeURIComponent(this.source);
        } catch (error) {
          return this.source;
        }
      },
      isTransientUrl() {
        const value = this.decodedSource || '';
        return value.startsWith('blob:') || value.startsWith('data:');
      },
      pdfData() {
        const sourceValue = this.decodedSource;
        if (!sourceValue) {
          return '';
        }

        if (sourceValue.startsWith('blob:') || sourceValue.startsWith('data:')) {
          return `/pdf/web/viewer.html?file=${encodeURIComponent(sourceValue)}`;
        }

        const sanitizedApiUrl = (process.env.VUE_APP_CTC_API || '').replace(/\/$/, '');
        const filename = sourceValue;
        let filePath = `/api/print/pdf?filename=${filename}`;

        if (sanitizedApiUrl) {
          try {
            const apiOrigin = new URL(sanitizedApiUrl, window.location.origin).origin;
            const viewerOrigin = window.location.origin;

            if (apiOrigin === viewerOrigin) {
              filePath = `${sanitizedApiUrl}/api/print/pdf?filename=${filename}`;
            } else {
              console.warn('PDF viewer falling back to same-origin request to avoid cross-origin restrictions.');
            }
          } catch (err) {
            console.warn('Unable to parse API URL for PDF viewer, using relative path.', err);
          }
        }

        return `/pdf/web/viewer.html?file=${encodeURIComponent(filePath)}`;
      },
      showReturnLink() {
        return this.$route.query.returnTo === 'acidDocuments';
      }
    },
    methods: {
      navigateBack() {
        this.$router.push({ name: 'acidDocuments' });
      },
      loadCSS() {
        const iframe = this.$refs.pdfFrame;
        iframe.addEventListener('load', () => {
          try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

            //Block right clicks
            iframeDoc.addEventListener("contextmenu", (e) => { e.preventDefault(); });
            if (iframe.contentWindow) {
              iframe.contentWindow.addEventListener("contextmenu", (e) => { e.preventDefault(); });
            }

            //Hide specific toolbar items
            const style = document.createElement("style");
            style.textContent = `
              #toolbarViewerRight {
                display: none !important;
              }
            `;

            iframeDoc.head.appendChild(style);
          } catch (e) {
            console.error('Could not customize PDF viewer due to cross-origin issue:', e);
          }
        });
      }
    },
    mounted() {
      if (!this.decodedSource) {
        this.$buefy && this.$buefy.toast && this.$buefy.toast.open({
          message: 'Document source missing. Returning to documents list.',
          type: 'is-danger'
        });
        this.$router.push({ name: 'acidDocuments' });
        return;
      }

      if (!this.$store.getters.user.IsACID) {
        this.$router.push({ name: 'restricted' });
      }
      else {
        if (this.isTransientUrl) {
          this.resolvedObjectUrl = this.decodedSource;
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loadCSS();
        })
      }
    },
    beforeDestroy() {
      if (this.resolvedObjectUrl && this.resolvedObjectUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.resolvedObjectUrl);
      }
    }
  }
</script>
